import axios from "axios";
import store from "@/store.js";

// const APIBASEURL = "http://127.0.0.1:15400/api/v2";
const APIBASEURL = "https://api.gune.kr/api/v2";

export const API = axios.create({
  baseURL: APIBASEURL,
  timeout: 20000,
});

export function ApiService() {
  if (store.state.auth !== null) {
    API.defaults.headers.common["Authorization"] = `Bearer ${store.state.auth}`;
  } else {
    delete API.defaults.headers.common["Authorization"];
  }
  return API;
}
